import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import { Target, Sliders, Shield, TrendingUp, AlertTriangle, Calendar, Mail } from 'lucide-react';

const SettingsDisplay = ({
  settings,
  fetchBotStatus,
  setSettingsOpen,
}) => {
  return (
    <Card className="matrix-card rounded-none" data-testid="settings-card">
      <CardHeader className="border-b border-[#003B00] p-4">
        <CardTitle className="text-sm uppercase tracking-widest flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Target className="h-4 w-4" strokeWidth={1.5} />
            TRADING SETTINGS
          </div>
          <Button
            onClick={async () => {
              await fetchBotStatus();
              setSettingsOpen(true);
            }}
            className="matrix-btn rounded-none h-7 px-2 text-xs"
            data-testid="edit-settings-btn"
          >
            <Sliders className="h-3 w-3 mr-1" strokeWidth={1.5} />
            EDIT
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-[#008F11] text-sm">RSI OVERSOLD (BUY)</span>
          <span className="font-bold text-[#00FF41]">{settings.rsi_oversold}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[#008F11] text-sm">RSI OVERBOUGHT (SELL)</span>
          <span className="font-bold text-red-500">{settings.rsi_overbought}</span>
        </div>
        <Separator className="bg-[#003B00]" />
        {settings.stop_loss_enabled && (
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-sm flex items-center gap-1">
              <Shield className="h-3 w-3 text-red-500" />
              STOP-LOSS
            </span>
            <span className="font-bold text-red-500">{settings.stop_loss_percent}%</span>
          </div>
        )}
        {settings.take_profit_enabled && (
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-sm flex items-center gap-1">
              <TrendingUp className="h-3 w-3 text-[#00FF41]" />
              TAKE-PROFIT
            </span>
            <span className="font-bold text-[#00FF41]">{settings.take_profit_percent}%</span>
          </div>
        )}
        {settings.trailing_stop_enabled && (
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-sm flex items-center gap-1">
              <AlertTriangle className="h-3 w-3 text-yellow-500" />
              TRAILING STOP
            </span>
            <span className="font-bold text-yellow-500">{settings.trailing_stop_percent}%</span>
          </div>
        )}
        {settings.schedule_enabled && (
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-sm flex items-center gap-1">
              <Calendar className="h-3 w-3" />
              SCHEDULE
            </span>
            <span className="font-bold text-xs">{settings.schedule_start_hour}:00-{settings.schedule_end_hour}:00 UTC</span>
          </div>
        )}
        {settings.email_alerts_enabled && (
          <div className="flex justify-between items-center">
            <span className="text-[#008F11] text-sm flex items-center gap-1">
              <Mail className="h-3 w-3" />
              EMAIL ALERTS
            </span>
            <span className="font-bold text-[#00FF41]">ON</span>
          </div>
        )}
        <Separator className="bg-[#003B00]" />
        <div className="flex justify-between items-center">
          <span className="text-[#008F11] text-sm">TRADE SIZE</span>
          <span className="font-bold">
            {settings.use_percent ? `${settings.trade_percent}%` : `$${settings.trade_amount}`}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[#008F11] text-sm">ACTIVE PAIRS</span>
          <span className="font-bold text-xs">{settings.active_pairs?.join(', ') || 'BTC-USD'}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default SettingsDisplay;
